export default __webpack_public_path__ + "static/media/email.785271c7.svg";